type CategorySources = {
  ageCategories?: readonly unknown[];
  weightCategories?: readonly unknown[];
  disciplineAgeCategories?: readonly unknown[];
  disciplineWeightCategories?: readonly unknown[];
};

function mergeCategories(
  categories: readonly unknown[] = [],
  customCategories: readonly unknown[] = [],
): unknown[] {
  const result = [...categories];
  const ids = new Set(
    categories.map((item) => (item as { id?: unknown } | null)?.id),
  );
  for (const item of customCategories) {
    const id = (item as { id?: unknown } | null)?.id;
    if (id != null && !ids.has(id)) {
      ids.add(id);
      result.push(item);
    }
  }
  return result;
}

/** Common category variables include custom catalogs; legacy aliases stay readable. */
export function withCustomDisciplineCategoryReferences<
  T extends CategorySources,
>(sources: T) {
  return {
    ...sources,
    ageCategories: mergeCategories(
      sources.ageCategories,
      sources.disciplineAgeCategories,
    ),
    weightCategories: mergeCategories(
      sources.weightCategories,
      sources.disciplineWeightCategories,
    ),
  };
}
